import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { parseDate } from 'utils';
import Close from 'assets/svg-icons/Close';

import { EYE, FREQUENCY, DURATION } from './consts';
import { Container, Text, Button } from './styles';

export default function MedicationItem({
  id,
  drugName,
  quantity,
  eye,
  frequency,
  duration,
  validFrom,
  validTo,
  retainAfterExamination,
  onDelete,
  readMode,
  disabled,
}) {
  const [string2, string3] = useMemo(
    () => [
      [EYE[eye], FREQUENCY[frequency]].filter(Boolean).join(', '),
      [DURATION[duration], validFrom && validTo && [parseDate(validFrom), parseDate(validTo)].join(' – ')]
        .filter(Boolean)
        .join(', '),
    ],
    [duration, eye, frequency, validFrom, validTo]
  );
  const onClick = useCallback(() => onDelete(id), [id, onDelete]);

  return (
    <Container $readMode={readMode}>
      <div>
        <Text>
          {drugName}, {quantity || 0} OP
        </Text>
        {string2 && <Text>{string2}</Text>}
        {string3 && <Text>{string3}</Text>}
        {retainAfterExamination && <Text>Dauerrezept</Text>}
      </div>
      {!readMode && (
        <Button type="button" onClick={onClick} disabled={disabled}>
          <Close />
        </Button>
      )}
    </Container>
  );
}

MedicationItem.defaultProps = {
  drugName: '-',
  quantity: 0,
  eye: null,
  frequency: null,
  duration: null,
  validFrom: null,
  validTo: null,
  retainAfterExamination: false,
  disabled: false,
};
MedicationItem.propTypes = {
  id: PropTypes.string.isRequired,
  drugName: PropTypes.string,
  quantity: PropTypes.number,
  eye: PropTypes.string,
  frequency: PropTypes.string,
  duration: PropTypes.string,
  validFrom: PropTypes.string,
  validTo: PropTypes.string,
  retainAfterExamination: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  readMode: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
